export interface MovimientoTesoreria {
  idMovimientoTesoreria: number;
  numero: string;
  idCajaBanco: number;
  cajaBancoNombre: string | null;
  tipoMovimiento: string;
  fechaMovimiento: string;
  fechaRegistro: string;
  idMoneda: number;
  monedaSimbolo: string | null;
  tipoCambio: number;
  montoTotal: number;
  montoTotalME: number | null;
  tipoAuxiliar: string | null;
  idPersona: number | null;
  nombreAuxiliar: string | null;
  idArea: number | null;
  idCentroCosto: number | null;
  idFormaPago: number | null;
  formaPagoNombre: string | null;
  tipoOperacion: string | null;
  numeroOperacion: string | null;
  numeroCheque: string | null;
  glosa: string | null;
  esProvision: boolean;
  estado: string;
  usuarioCreaNombre: string | null;
  fechaAnulacion: string | null;
  detalles: MovimientoTesoreriaDetalle[];
}

export interface MovimientoTesoreriaDetalle {
  idMovimientoTesoreriaDetalle: number;
  numeroLinea: number;
  cuentaContable: string | null;
  idPersona: number | null;
  personaNombre: string | null;
  tipoDocumento: string | null;
  serieDocumento: string | null;
  numeroDocumento: string | null;
  montoMonedaNacional: number;
  montoMonedaExtranjera: number | null;
  glosa: string | null;
  fechaEmision: string | null;
  fechaVencimiento: string | null;
  idMovimientoRelacionado: number | null;
}

export interface MovimientoTesoreriaFiltro {
  fechaInicio?: string;
  fechaFin?: string;
  idCajaBanco?: number;
  tipoMovimiento?: string;
  estado?: string;
  tipoAuxiliar?: string;
  idPersona?: number;
}

export interface DocumentoPendiente {
  idMovimiento: number;
  tipoDocumento: string | null;
  serieDocumento: string | null;
  numeroDocumento: string | null;
  fechaEmision: string | null;
  fechaVencimiento: string | null;
  importeTotal: number;
  importePagado: number;
  saldo: number;
  nombreAuxiliar: string | null;
  idPersona: number | null;
  monedaSimbolo: string | null;
}

export const TIPOS_MOVIMIENTO = [
  { value: 'INGRESO', label: 'Ingreso' },
  { value: 'EGRESO', label: 'Egreso' },
];

export const TIPOS_AUXILIAR = [
  { value: 'CLIENTE', label: 'Cliente' },
  { value: 'PROVEEDOR', label: 'Proveedor' },
  { value: 'TRABAJADOR', label: 'Trabajador' },
  { value: 'TRANSPORTISTA', label: 'Transportista' },
];

export const ESTADOS_MOVIMIENTO = [
  { value: 'ACTIVO', label: 'Activo' },
  { value: 'ANULADO', label: 'Anulado' },
];

export const initialMovimientoDetalle: MovimientoTesoreriaDetalle = {
  idMovimientoTesoreriaDetalle: 0,
  numeroLinea: 0,
  cuentaContable: null,
  idPersona: null,
  personaNombre: null,
  tipoDocumento: null,
  serieDocumento: null,
  numeroDocumento: null,
  montoMonedaNacional: 0,
  montoMonedaExtranjera: null,
  glosa: null,
  fechaEmision: null,
  fechaVencimiento: null,
  idMovimientoRelacionado: null,
};
